import React, { Component, Fragment } from 'react';
import {
    Card,
    Form,
    Row,
    Col,
    Select,
    Input,
    Button,
    Empty,
    Divider,
    Table,
    InputNumber,
    Checkbox,
    Tag
} from 'antd';
import { inject, observer } from 'mobx-react';
const Option = Select.Option;

@inject('store')
@observer
class FormComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            strategy: '',
            type: '',
            hide_indicators: false,
            strategies: (props.data && props.data.strategies) || []
        };
    }

    componentDidMount() {
        this.props.store.strategyStore.getOdysseyStrategies();
    }

    async addStrategy() {
        const { setFieldsValue } = this.props.form;
        let next = [...this.state.strategies];
        if (!this.state.strategy.length) return;

        if (this.props.botType === 'apex') {
            next.push({
                ...this.props.store.strategyStore.getStrategy(this.state.strategy),
                meta: { hide_indicators: this.state.hide_indicators }
            });
        } else {
            const strat = await this.props.store.strategyStore.getXStrategy(this.state.strategy);

            next.push({
                ...strat,
                meta: { hide_indicators: this.state.hide_indicators }
            });
        }

        this.setState({ strategies: next, strategy: '', hide_indicators: false });
        setFieldsValue({ strategies: next });
    }

    render() {
        const { getFieldDecorator } = this.props.form;

        getFieldDecorator('strategies', { initialValue: [] });
        console.log(this.props.botType);
        return (
            <Fragment>
                <Card
                    size="small"
                    title={this.props.title}
                    bordered={false}
                    style={{ marginBottom: 15 }}
                >
                    <Form>
                        <Row gutter={24}>
                            <Col md={3}>
                                <Form.Item label="Published">
                                    {getFieldDecorator('published', {
                                        initialValue: 'draft'
                                    })(
                                        <Select>
                                            <Option value="draft">Draft</Option>
                                            <Option value="published">Publish</Option>
                                            <Option value="archive">Archive</Option>
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>

                            <Col md={8}>
                                <Form.Item label="Version">
                                    {getFieldDecorator('version', {
                                        rules: [{ required: true, message: 'Version is required' }],
                                        initialValue: this.props.id
                                    })(<InputNumber />)}
                                </Form.Item>
                            </Col>
                            <Col md={24}>
                                <Form.Item label="Update notes">
                                    {getFieldDecorator('update_notes', {
                                        initialValue: ''
                                    })(<Input.TextArea rows={5} />)}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Divider orientation={'left'}>Strategies</Divider>

                        <Row gutter={24}>
                            <Col md={3}>
                                <Form.Item label="Type">
                                    {this.props.botType === 'apex' ? (
                                        <Select
                                            value={this.state.type}
                                            onChange={val =>
                                                this.setState({ type: val, strategy: '' })
                                            }
                                        >
                                            <Option value="buy_sell">Buy/Sell</Option>
                                            <Option value="trigger">Automation</Option>
                                            <Option value="adca">Auto DCA</Option>
                                            <Option value="art">Auto Reverse Trading</Option>
                                            <Option value="signal">Signal</Option>
                                        </Select>
                                    ) : (
                                        <Select
                                            value={this.state.type}
                                            onChange={val =>
                                                this.setState({ type: val, strategy: '' })
                                            }
                                        >
                                            <Option value="odyssey_short">Short</Option>
                                            <Option value="odyssey_long">Long</Option>
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                            <Col md={6}>
                                <Form.Item label="Strategy">
                                    <Select
                                        showSearch
                                        style={{ width: '100%' }}
                                        value={this.state.strategy}
                                        onChange={val => this.setState({ strategy: val })}
                                        filterOption={(input, option) =>
                                            option.props.children
                                                .toLowerCase()
                                                .indexOf(input.toLowerCase()) >= 0
                                        }
                                        optionFilterProp="name"
                                    >
                                        {this.props.botType === 'apex'
                                            ? this.props.store.strategyStore
                                                  .getByType(this.state.type)
                                                  .slice()
                                                  .sort((a, b) => {
                                                      if (a.name < b.name) return -1;
                                                      if (a.name > b.name) return 1;
                                                      return 0;
                                                  })
                                                  .filter(s => {
                                                      if (s.meta) {
                                                          return (
                                                              s.meta.author_id ===
                                                              this.props.store.userStore.currentUser
                                                                  .uid
                                                          );
                                                      }
                                                      return true;
                                                  })
                                                  .map(s => {
                                                      return (
                                                          <Option value={s.id} key={s.id}>
                                                              {s.name}
                                                          </Option>
                                                      );
                                                  })
                                            : this.props.store.strategyStore
                                                  .getXByType(this.state.type)
                                                  .slice()
                                                  .sort((a, b) => {
                                                      if (a.name < b.name) return -1;
                                                      if (a.name > b.name) return 1;
                                                      return 0;
                                                  })
                                                  .filter(s => {
                                                      if (s.meta) {
                                                          return (
                                                              s.meta.author_id ===
                                                              this.props.store.userStore.currentUser
                                                                  .uid
                                                          );
                                                      }
                                                      return true;
                                                  })
                                                  .map(s => {
                                                      return (
                                                          <Option value={s._id} key={s._id}>
                                                              {s.name}
                                                          </Option>
                                                      );
                                                  })}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col md={3}>
                                <Form.Item label="Hide Indicators and Signals">
                                    <Checkbox
                                        checked={this.state.hide_indicators}
                                        onChange={e =>
                                            this.setState({ hide_indicators: e.target.checked })
                                        }
                                    />
                                </Form.Item>
                            </Col>
                            <Col md={2}>
                                <Form.Item>
                                    <Button
                                        onClick={this.addStrategy.bind(this)}
                                        style={{ marginTop: 41 }}
                                        type={'primary'}
                                    >
                                        Add
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                        {this.state.strategies.length ? (
                            <Table
                                rowKey={this.props.botType === 'apex' ? 'id' : '_id'}
                                columns={[
                                    {
                                        title: 'Name',
                                        dataIndex: 'name',
                                        key: 'name'
                                    },
                                    {
                                        title: 'Type',
                                        dataIndex: 'type',
                                        key: 'type',
                                        render: text => {
                                            switch (text) {
                                                case 'buy_sell':
                                                    return <Tag>Buy/Sell</Tag>;
                                                case 'trigger':
                                                    return <Tag>Automation</Tag>;
                                                case 'adca':
                                                    return <Tag>ADCA</Tag>;
                                                case 'art':
                                                    return <Tag>ART</Tag>;
                                                case 'signal':
                                                    return <Tag>Signal</Tag>;
                                                case 'odyssey_short':
                                                    return <Tag>Short</Tag>;
                                                case 'odyssey_long':
                                                    return <Tag>Long</Tag>;
                                                default:
                                                    return null;
                                            }
                                        }
                                    },
                                    {
                                        title: 'Hide Indicators',
                                        dataIndex: 'hide_indicators',
                                        key: 'hide_indicators',
                                        render: (text, o) => {
                                            return o.meta.hide_indicators ? 'Yes' : 'No';
                                        }
                                    },
                                    {
                                        title: 'Actions',
                                        dataIndex: 'actions',
                                        key: 'actions',
                                        render: (text, o) => {
                                            return (
                                                <Button
                                                    type={'danger'}
                                                    onClick={() => {
                                                        let next = [...this.state.strategies];
                                                        this.setState({
                                                            strategies: next.filter(
                                                                a => a.id !== o.id
                                                            )
                                                        });
                                                    }}
                                                >
                                                    Delete
                                                </Button>
                                            );
                                        }
                                    }
                                ]}
                                dataSource={this.state.strategies}
                            />
                        ) : (
                            <Empty description={<span>Attach Strategies</span>} />
                        )}
                    </Form>
                </Card>
            </Fragment>
        );
    }
}

export const VersionForm = Form.create({
    onValuesChange: (props, changes, all) => {
        props.onChange(all);
    },
    mapPropsToFields: props => {
        const data = {};
        Object.keys(props.data || {}).forEach(key => {
            data[key] = Form.createFormField({ value: props.data[key] });
        });
        return data;
    }
})(FormComponent);



// WEBPACK FOOTER //
// ./src/Account/StratCenter/Form/VersionForm.js